import { APIModel } from '@shared/interfaces';
import { PollingStatus } from './polling-status.enum';
import { StatusProvider } from './status-provider.enum';

export class PersonalTaxImport implements APIModel {
    id = -1;
    duration = 0; // In seconds
    status = PollingStatus.Init;
    statusMessage?: string;
    statusMessageProvider?: StatusProvider;
    creationDate = new Date();

    deserialize(data: any): this {
        this.id = data.id ?? -1;
        this.duration = data.duration ?? 0;
        this.status = data.status;
        this.statusMessage = data.status_message ?? undefined;
        this.statusMessageProvider = data.status_message_provider ?? undefined;
        this.creationDate = data.creation_date != null ? new Date(data.creation_date) : this.creationDate;
        return this;
    }

    serialize(): any {
        return {
            id: this.id,
            duration: this.duration,
            status: this.status,
            status_message: this.statusMessage,
            status_message_provider: this.statusMessageProvider,
            creation_date: this.creationDate.toISOString(),
        };
    }
}
